import http from 'plugins/axios';

export default {
  getCoinTypeList() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  },
  getBillTypeList() {
    return http.get({
      url: '/admin/u/bill/type'
    });
  },
  reqBills(data) {
    return http.get({
      url: '/admin/u/bill',
      data
    });
  },
  userBalanceAnalysis(data) {
    return http.get({
      url: '/admin/reconciliation/user/analysis',
      data
    });
  },
  getLook(data) {
    return http.get({
      url: '/admin/u/bill/getUserBalanceChangeHistoryInfo',
      data
    });
  }
};
